import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitolonavalacabs() {



  const cardData =
  {
    keyword: 'Mumbai to Lonavala Cab',
    heading: 'Shambhu Cabs: Mumbai to Lonavala Cab  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Lonavala Cab services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and weekend getaway groups heading to the scenic hill station of Lonavala. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Lonavala with spacious seating and well-maintained vehicles. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and convenient. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Lonavala cab services for travelers seeking comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Lonavala with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a popular monsoon destination near Lonavala, known for its cascading waters and scenic surroundings. Tourists enjoy wading through the flowing water, picnicking on the dam steps, and taking in the lush greenery of the Western Ghats during the rainy season."
  },
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap, also called Tiger’s Point, is a dramatic cliff offering breathtaking panoramic views of the Sahyadri mountains and lush valleys. Named for its resemblance to a leaping tiger, it is a favorite spot for sunrise, sunset, and photography enthusiasts."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake is a serene spot surrounded by hills and greenery, especially vibrant during the monsoon. Visitors enjoy peaceful walks, boating, and picnics by the water. It is an ideal escape for those seeking calm amidst nature."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historical fort located near Lonavala, popular for trekking and panoramic views of the Sahyadri ranges. The trek passes through dense forests, hills, and ancient ruins, offering a perfect blend of adventure, history, and natural beauty."
  },
  {
    "title": "Karla Caves",
    "description": "The Karla Caves are ancient Buddhist rock-cut caves dating back to the 2nd century BC. Known for their impressive chaityas (prayer halls) and intricate carvings, they reflect the rich cultural and religious history of the region and attract history enthusiasts and pilgrims alike."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort, a popular trekking destination, is known for its strong fortifications, historic gates, and panoramic views of the surrounding Western Ghats. The fort is especially lush and misty during the monsoon, making it a favorite for trekkers and nature lovers."
  },
  {
    "title": "Della Adventure Park",
    "description": "Della Adventure Park offers a range of outdoor activities including zip-lining, bungee jumping, dirt biking, and archery. It is perfect for thrill-seekers and families looking for adventure and fun in a scenic hill station environment."
  },
  {
    "title": "Ryewood Park and Garden",
    "description": "Ryewood Park is a beautifully maintained garden with walking paths, fountains, and lush greenery. It is ideal for a relaxing stroll, photography, and enjoying the calm environment away from the bustling town center."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a picturesque artificial lake surrounded by hills, popular for camping, boating, and evening picnics. The tranquil waters and stunning sunsets make it one of the most visited spots near Lonavala."
  },
  {
    "title": "Kune Waterfalls",
    "description": "Kune Waterfalls, located near Lonavala, is a beautiful cascading waterfall surrounded by lush greenery and misty mountains. It is especially spectacular during the monsoon and a perfect spot for nature lovers and photography enthusiasts."
  }
],


"services": [
  {
    "name": "Mumbai Lonavala Taxi",
    "description": "Mumbai Lonavala Taxi offers reliable and comfortable travel for passengers heading from Mumbai to the scenic hill station of Lonavala. This service provides well-maintained vehicles, professional drivers familiar with the Mumbai–Lonavala route, and flexible pickup and drop options. Ideal for families, couples, and solo travelers, the taxi ensures a safe, hassle-free journey through the picturesque Western Ghats, making it perfect for weekend getaways or leisure trips."
  },
  {
    "name": "Lonavala Trip Cab Mumbai",
    "description": "Lonavala Trip Cab Mumbai specializes in complete cab services for leisure trips to Lonavala. The service includes comfortable sedans and SUVs, experienced drivers, and flexible scheduling. Travelers can enjoy scenic routes, timely arrivals, and a stress-free journey. This option is ideal for families, friends, and small groups seeking an organized and convenient travel experience for hill station tours."
  },
  {
    "name": "Mumbai to Lonavala One-Way Cab",
    "description": "Mumbai to Lonavala One-Way Cab is designed for passengers who require single-direction travel from Mumbai to Lonavala without the need for a return trip. The service offers economical options, professional drivers, and well-maintained vehicles. Perfect for weekend getaways, short trips, or hotel check-ins, this cab ensures a smooth and comfortable journey to Lonavala with minimal hassle."
  },
  {
    "name": "Affordable Cab Mumbai Lonavala",
    "description": "Affordable Cab Mumbai Lonavala provides budget-friendly taxi services for travelers looking to reach Lonavala without compromising comfort or safety. Vehicles are maintained to high standards, drivers are professional, and the service includes flexible scheduling and on-time pickups. Ideal for students, families, or groups, this service combines affordability with reliability for an enjoyable hill station trip."
  },
  {
    "name": "Best Taxi Mumbai Lonavala",
    "description": "Best Taxi Mumbai Lonavala is known for its superior service, punctuality, and well-maintained vehicles. The service caters to families, solo travelers, and groups, offering professional drivers and comfortable rides. Passengers can enjoy scenic drives, timely arrivals, and a hassle-free journey, making it a preferred choice for weekend trips or leisure travel to Lonavala."
  },
  {
    "name": "SUV Cab Mumbai Lonavala",
    "description": "SUV Cab Mumbai Lonavala is ideal for families or groups seeking spacious, comfortable, and safe travel from Mumbai to Lonavala. Equipped with modern amenities and safety features, these SUVs provide a smooth ride over highways and hilly terrains. Professional drivers ensure timely pickups and drop-offs, allowing passengers to relax and enjoy the scenic journey."
  },
  {
    "name": "Sedan Cab Mumbai Lonavala",
    "description": "Sedan Cab Mumbai Lonavala offers comfortable and economical travel for solo travelers, couples, or small families. Well-maintained sedans, experienced drivers, and on-time service make the journey safe and stress-free. This service provides an efficient and enjoyable way to reach Lonavala while ensuring comfort and reliability throughout the trip."
  },
  {
    "name": "Mumbai Lonavala Hill Station Cab",
    "description": "Mumbai Lonavala Hill Station Cab specializes in hill station travel, providing reliable transportation from Mumbai to Lonavala. The service includes scenic route planning, professional drivers, and comfortable vehicles suitable for all group sizes. Passengers can enjoy the beautiful Western Ghats landscape while traveling safely and efficiently to their leisure destination."
  },
  {
    "name": "24×7 Mumbai Lonavala Cab",
    "description": "24×7 Mumbai Lonavala Cab offers round-the-clock taxi services for travelers needing flexible departure or return times. Whether it's early morning or late-night travel, the service ensures well-maintained vehicles, professional drivers, and safe travel. This option provides convenience and reliability for both planned and last-minute trips to Lonavala."
  },
  {
    "name": "Express Highway Cab Lonavala",
    "description": "Express Highway Cab Lonavala ensures fast and comfortable travel from Mumbai to Lonavala via the Mumbai–Pune Expressway. The service includes professional drivers skilled in highway driving, well-maintained vehicles, and timely pickups. Ideal for business travelers or weekend tourists, it offers a smooth and stress-free journey to the hill station."
  },
  {
    "name": "Mumbai Lonavala Outstation Taxi",
    "description": "Mumbai Lonavala Outstation Taxi provides a dependable solution for long-distance travel between Mumbai and Lonavala. Passengers can enjoy spacious, well-maintained vehicles and professional drivers who ensure a safe and comfortable ride. This service is ideal for weekend getaways, family trips, or group outings to the scenic hill station."
  },
  {
    "name": "Fast Cab Mumbai Lonavala",
    "description": "Fast Cab Mumbai Lonavala is designed for passengers seeking quick and efficient travel between Mumbai and Lonavala. The service combines professional drivers, highway-optimized routes, and comfortable vehicles to ensure timely arrivals. Perfect for business travelers or those on tight schedules, it provides a smooth, hassle-free journey."
  },
  {
    "name": "Family Trip Cab Mumbai Lonavala",
    "description": "Family Trip Cab Mumbai Lonavala caters specifically to families traveling together. Spacious vehicles, professional drivers, and flexible scheduling make the trip safe, comfortable, and enjoyable. Passengers can focus on leisure and sightseeing while the service ensures timely arrivals and a stress-free travel experience."
  },
  {
    "name": "Premium Cab Mumbai Lonavala",
    "description": "Premium Cab Mumbai Lonavala offers luxury travel options for passengers seeking comfort and style. High-end vehicles, professional chauffeurs, and personalized services ensure a top-notch experience. This service is ideal for travelers who want a smooth, comfortable, and memorable journey to the hill station."
  },
  {
    "name": "Corporate Cab Mumbai Lonavala",
    "description": "Corporate Cab Mumbai Lonavala provides professional and reliable transport solutions for corporate travelers and business groups. Vehicles are equipped with all necessary amenities, and experienced drivers ensure timely pickups and drop-offs. This service ensures comfortable and efficient travel for meetings, corporate events, or team outings in Lonavala."
  },
  {
    "name": "Mumbai Lonavala Pickup Drop",
    "description": "Mumbai Lonavala Pickup Drop service ensures seamless door-to-door transportation for passengers traveling between Mumbai and Lonavala. With professional drivers, well-maintained vehicles, and flexible scheduling, travelers can enjoy a stress-free journey without worrying about logistics. Ideal for all types of trips, from weekend getaways to business visits."
  },
  {
    "name": "Mumbai to Bushi Dam Cab",
    "description": "Mumbai to Bushi Dam Cab provides direct transportation to the scenic Bushi Dam near Lonavala. The service includes comfortable vehicles, professional drivers, and reliable timing. Perfect for families, couples, and groups looking to explore the dam and surrounding areas, it ensures a safe, enjoyable, and convenient travel experience."
  }
],

"tableData": [
  ["Mumbai Lonavala Taxi", "Lonavala Trip Cab Mumbai"],
  ["Mumbai to Lonavala One-Way Cab", "Affordable Cab Mumbai Lonavala"],
  ["Best Taxi Mumbai Lonavala", "SUV Cab Mumbai Lonavala"],
  ["Sedan Cab Mumbai Lonavala", "Mumbai Lonavala Hill Station Cab"],
  ["24×7 Mumbai Lonavala Cab", "Express Highway Cab Lonavala"],
  ["Mumbai Lonavala Outstation Taxi", "Fast Cab Mumbai Lonavala"],
  ["Family Trip Cab Mumbai Lonavala", "Premium Cab Mumbai Lonavala"],
  ["Corporate Cab Mumbai Lonavala", "Mumbai Lonavala Pickup Drop"],
  ["Mumbai to Bushi Dam Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Lonavala Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Lonavala cab services, perfect for weekend getaways, hill station trips, and comfortable long-distance travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey to Lonavala."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghat and Hill Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai to Lonavala ghat and hill routes, ensuring safe, timely, and comfortable travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront and clear pricing—fuel, tolls, and driver allowances included—making your Mumbai to Lonavala cab trip hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to help with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Hill Station Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable rental plans tailored to your Mumbai to Lonavala travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Lonavala journey stress-free and comfortable."
  }
]




















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Lonavala cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Lonavala cab services with experienced and professional drivers.',
  },
  {
    question: 'How can I book a Mumbai to Lonavala cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Lonavala cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars ideal for a comfortable trip from Mumbai to Lonavala.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Lonavala route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Lonavala route to ensure a safe and smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Lonavala cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Lonavala.',
  },
  {
    question: 'Is the Mumbai to Lonavala cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Lonavala cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Lonavala cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure passenger safety.',
  },
  {
    question: 'What payment options are available for Mumbai to Lonavala cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Lonavala journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Lonavala travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Our Mumbai to Lonavala trip with Shambhu Cabs was smooth and enjoyable. The car was clean and the driver courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshpande',
    feedback: 'Highly reliable Mumbai to Lonavala cab service. Shambhu Cabs made our weekend getaway comfortable and hassle-free.',
    rating: 5,
  },
];













































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lonavala Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-lonavala-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Lonavala cab services for comfortable travel. Ideal for one-way or round trips to Lonavala hill station, family outings, corporate trips, and Bushi Dam visits. Choose from sedans, SUVs, and premium cars with professional drivers and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-lonavala-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Mumbai to Lonavala Cab | Hill Station & Outstation Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Lonavala cab with Shambhu Cabs. Affordable, fast, and comfortable taxi service for hill station trips, family outings, corporate travel, and Bushi Dam visits. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Lonavala Taxi, Lonavala Trip Cab Mumbai, Mumbai to Lonavala One-Way Cab, Affordable Cab Mumbai Lonavala, Best Taxi Mumbai Lonavala, SUV Cab Mumbai Lonavala, Sedan Cab Mumbai Lonavala, Mumbai Lonavala Hill Station Cab, 24×7 Mumbai Lonavala Cab, Express Highway Cab Lonavala, Mumbai Lonavala Outstation Taxi, Fast Cab Mumbai Lonavala, Family Trip Cab Mumbai Lonavala, Premium Cab Mumbai Lonavala, Corporate Cab Mumbai Lonavala, Mumbai Lonavala Pickup Drop, Mumbai to Bushi Dam Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitolonavalacabs;